import React, { memo, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "../css/PeoplesTile.css";
import Loader from "../Sub_components/Loader";
import { useLiveStreamAppContext } from "../ContextStore/Store";

function IframeModal() {
  const {
    showUrl,
    showIframe,
    setShowIframe,
    setLoading,
    loading,
    setToggleStates,
  } = useLiveStreamAppContext();
  const [popupValue, setPopupValue] = useState();

  //Loader Hide on Page Load
  const handleIframeLoad = () => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  //useEffect for Handling Not Now Button Click on Restore File Option in Vagaro Drive Enable Popup
  useEffect(() => {
    window.addEventListener("message", (event) => {
      if (event.data === "closeLivestreamIframe") {
        setShowIframe(false);
      }
    });
  }, []);

  //useEffect for Fetching popuptype
  useEffect(() => {
    if (showUrl) {
      let url = new URL(showUrl);
      let params = new URLSearchParams(url.search);
      setPopupValue(params.get("popuptype"));
    }
  }, [showUrl]);

  return (
    <Modal
      show={showIframe}
      centered
      id="iFrameModal"
      backdrop="static"
      dialogClassName={`attendee-modal-size drive-modal-react history-modal ${
        popupValue === "vagarodrive" && "driveclose-btn"
      } ${popupValue === "license" && "licensePopup driveclose-btn"}`}
    >
      <Modal.Body className="default-scrollbar">
        {
          <i
            className="close-button font-awesome-light-pro live-popup-close"
            onClick={() => {
              setShowIframe(false);
              if (popupValue === "license") {
                window.location.reload();
              }
              if (popupValue === "vagarodrive") {
                setToggleStates((prevStates) => ({
                  ...prevStates,
                  StartRecording: false,
                }));
              }
            }}
            style={{ cursor: "pointer" }}
          >
            &#xf00d;
          </i>
        }
        {loading && <Loader />}
        <iframe
          className="historyiframe"
          scrolling={"no"}
          frameBorder={0}
          id="iFrame_DivCustomerHistoryPopUp"
          src={showUrl} // Use src instead of srcDoc for URL loading
          title="Customer Profile display"
          onLoad={handleIframeLoad} // Set onLoad event to handle iframe loading
        />
      </Modal.Body>
    </Modal>
  );
}

export default memo(IframeModal);
